import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white/90 font-sans selection:bg-violet-electric/30" data-id="element-1658">
      {/* Hero Section */}
      <section id="hero" className="relative pt-32 pb-16 px-6" data-id="element-1659">
        <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-1660">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1661">

            <span className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-1662">
              Legal
            </span>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight tracking-tight mb-6 bg-clip-text text-transparent bg-gradient-to-b from-white to-white/70" data-id="element-1663">
              Terms & Privacy
            </h1>
            <p className="text-white/50 text-base" data-id="element-1664">
              Last Updated: September 3, 2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <article className="relative z-10 max-w-3xl mx-auto px-6 pb-32" data-id="element-1665">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:text-white prose-headings:font-bold prose-p:text-white/80 prose-p:leading-relaxed prose-strong:text-white prose-li:text-white/80" data-id="element-1666">
          {/* EULA */}
          <section id="eula" data-id="element-1667">
            <h2 className="text-3xl mt-8 mb-8" data-id="element-1668">
              End User License Agreement (EULA)
            </h2>

            <p data-id="element-1669">
              This End User License Agreement ("Agreement") is a legal agreement
              between you ("Licensee" or "you") and Redshift Enterprises
              ("Licensor" or "we") regarding your use of Thruline ("Software").
              By installing, copying, or otherwise using the Software, you agree
              to be bound by the terms of this Agreement.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1670">
              1. License Grant
            </h3>

            <p data-id="element-1671">
              <strong data-id="element-1672">1.1 License:</strong> Subject to the terms and conditions
              of this Agreement, Licensor grants you a non-exclusive,
              non-transferable, limited license to install and use the Software
              on a single device for personal or internal business purposes.
            </p>

            <p data-id="element-1673">
              <strong data-id="element-1674">1.2 Restrictions:</strong> You may not:
            </p>
            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-1675">
              <li data-id="element-1676">
                Modify, adapt, translate, or create derivative works based on
                the Software.
              </li>
              <li data-id="element-1677">
                Reverse engineer, decompile, disassemble, or attempt to derive
                the source code of the Software.
              </li>
              <li data-id="element-1678">
                Redistribute, sell, rent, lease, or sublicense the Software to
                any third party.
              </li>
              <li data-id="element-1679">
                Remove, alter, or obscure any proprietary notices on the
                Software.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1680">
              2. Intellectual Property Rights
            </h3>

            <p data-id="element-1681">
              <strong data-id="element-1682">2.1 Ownership:</strong> The Software and all related
              materials are protected by intellectual property laws and
              treaties. Licensor retains all rights, title, and interest in and
              to the Software, including all intellectual property rights
              therein.
            </p>

            <p data-id="element-1683">
              <strong data-id="element-1684">2.2 Trademarks:</strong> All trademarks, service marks,
              logos, and trade names associated with the Software are the
              property of Licensor or its licensors.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1685">
              3. Limitation of Liability
            </h3>

            <p data-id="element-1686">
              <strong data-id="element-1687">3.1 Disclaimer:</strong> The Software is provided "AS IS"
              without warranty of any kind, either express or implied, including
              but not limited to the implied warranties of merchantability,
              fitness for a particular purpose, and non-infringement.
            </p>

            <p data-id="element-1688">
              <strong data-id="element-1689">3.2 Limitation:</strong> To the maximum extent permitted
              by applicable law, in no event shall Licensor be liable for any
              special, incidental, indirect, or consequential damages whatsoever
              arising out of the use of or inability to use the Software.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1690">
              4. Termination
            </h3>

            <p data-id="element-1691">
              <strong data-id="element-1692">4.1 Termination by Licensor:</strong> Licensor may
              terminate this Agreement at any time if you fail to comply with
              any term or condition of this Agreement.
            </p>

            <p data-id="element-1693">
              <strong data-id="element-1694">4.2 Effect of Termination:</strong> Upon termination, you
              must cease all use of the Software and destroy all copies of the
              Software in your possession or control.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1695">
              5. Governing Law
            </h3>

            <p data-id="element-1696">
              This Agreement shall be governed by and construed in accordance
              with the laws of the applicable jurisdiction, without regard to
              its conflict of law principles.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1697">
              6. Miscellaneous
            </h3>

            <p data-id="element-1698">
              <strong data-id="element-1699">6.1 Severability:</strong> If any provision of this
              Agreement is found to be invalid or unenforceable, the remaining
              provisions shall remain in full force and effect.
            </p>

            <p data-id="element-1700">
              <strong data-id="element-1701">6.2 Entire Agreement:</strong> This Agreement constitutes
              the entire agreement between you and Licensor with respect to the
              Software and supersedes all prior or contemporaneous
              understandings or agreements.
            </p>

            <p data-id="element-1702">
              <strong data-id="element-1703">6.3 Amendments:</strong> Licensor reserves the right to
              modify this Agreement at any time, and such modifications will be
              effective upon notice to you.
            </p>

            <p className="text-white/60 text-sm uppercase tracking-wide mt-8 p-4 rounded-xl border border-white/[0.06] bg-white/[0.02]" data-id="element-1704">
              By installing or using the Software, you acknowledge that you have
              read this Agreement, understand it, and agree to be bound by its
              terms and conditions.
            </p>
          </section>

          <hr className="border-white/10 my-16" data-id="element-1705" />

          {/* Privacy Policy */}
          <section id="privacy" data-id="element-1706">
            <h2 className="text-3xl mt-16 mb-8" data-id="element-1707">Privacy Policy</h2>

            <p data-id="element-1708">
              This Privacy Policy applies to your use of our website, which
              includes our subscription services (our "Service") and our
              software ("Software").
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1709">
              1. Information We Collect
            </h3>

            <p data-id="element-1710">We collect information in two ways:</p>

            <p data-id="element-1711">
              <strong data-id="element-1712">Information you give us.</strong> For example, some of our
              Services require you to log-in and create an account. When you
              set-up an account, we'll ask you for personal information (more
              fully defined below), like your name, email address, telephone
              number and your credit card number, if necessary.
            </p>

            <p data-id="element-1713">
              <strong data-id="element-1714">Information we get from your use of our Services.</strong>{' '}
              We may collect information about the Services that you use and how
              you use them, like when you visit our website. This information
              includes:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-1715">
              <li data-id="element-1716">
                <strong data-id="element-1717">Device Information</strong> — we may collect
                device-specific information (such as your hardware model,
                operating system version, unique device identifiers, and mobile
                network information including phone number). We may associate
                your device identifiers or phone number with your account.
              </li>
              <li data-id="element-1718">
                <strong data-id="element-1719">Log information</strong> — when you use our Services or
                view content that we provide, we may automatically collect and
                store certain information in server logs. This may include
                details of how you used our Services, such as your search
                queries, Internet protocol address, and device event information
                such as crashes or other system activity.
              </li>
              <li data-id="element-1720">
                <strong data-id="element-1721">Location information</strong> — when you agree to use a
                location-enabled service, we may collect and process information
                about your exact location.
              </li>
              <li data-id="element-1722">
                <strong data-id="element-1723">Local storage</strong> — we may collect and store
                information locally on your device using mechanisms such as
                browser web storage and application data caches.
              </li>
            </ul>

            <p data-id="element-1724">
              "Personal information" means information that specifically
              identifies you, including but not limited to your name, address,
              telephone number, email address and credit card information.
            </p>

            <p data-id="element-1725">
              <strong data-id="element-1726">Cookies.</strong> In order to improve our Service and
              provide a more relevant experience to our users, we may collect
              information using "cookies." Cookies are small data files stored
              on your hard drive by a website. We may use cookies to see which
              areas and features are popular and to count visits to our Service.
              Most web browsers are set to accept cookies by default. If you
              prefer, you can usually choose to set your browser to remove
              and/or reject cookies. If we use cookies and you choose to remove
              or reject them, this could affect certain features of our Service.
            </p>

            <p data-id="element-1727">
              <strong data-id="element-1728">Third Party Cookies.</strong> We may also allow third
              parties, such as Google, to use cookies on our Service. Such third
              party cookies are used to help recognize your log-in status and
              permit you to access third party features enabled through our
              Service and to evaluate and compile aggregated statistics about
              activity on our Service. You can usually choose to set your
              browser to remove and/or reject these cookies, but note that doing
              so could affect certain features of our Service.
            </p>

            <p data-id="element-1729">
              Our Service may require you to use the most current version of the
              Software. The Software may automatically check to determine if you
              are using the most current version of the Software. During this
              process, an IP address identifying your computer, operating system
              version and the Software version may be collected via the
              Internet.
            </p>

            <p data-id="element-1730">
              We may on occasion supplement the personal information you submit
              to us with information from third-party sources. For example, if
              permitted under applicable law, we may supplement the information
              you provide when you register for an account with address
              information provided by the U.S. Postal Service to verify your
              information and prevent errors in our database.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1731">
              2. How We Use the Information We Collect
            </h3>

            <p data-id="element-1732">
              In general, we use personal information we collect for the
              purposes described in this Privacy Policy or otherwise disclosed
              to you through our Service. For example, we may use your
              information:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-1733">
              <li data-id="element-1734">To provide and improve the Service and the Software;</li>
              <li data-id="element-1735">
                To send you a welcome email and contact you about your use of
                the Service or Software (e.g., for administrative and customer
                service purposes);
              </li>
              <li data-id="element-1736">
                To process your requests or transactions and to send you related
                information, including confirmations, invoices, technical
                notices, updates, security alerts and support and administrative
                messages;
              </li>
              <li data-id="element-1737">
                To provide you with information, products or services you
                request;
              </li>
              <li data-id="element-1738">
                To track customer preferences and inform you about product
                upgrades, special offers and products and our services that we
                think will be of interest to you;
              </li>
              <li data-id="element-1739">
                To respond to your emails, submissions, feedback, bug reports,
                requests for new features, help requests or other comments,
                questions or complaints;
              </li>
              <li data-id="element-1740">
                To monitor and analyze usage, trends and activities in
                connection with the Service and Software;
              </li>
              <li data-id="element-1741">
                To automatically determine if you are using the most current
                version of the Software and to send you email messages, and
                potentially a pop-up box or similar notification mechanisms to
                inform you if you need to upgrade in order to use the Service
                you have requested.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1742">
              3. Sharing of Personal Information
            </h3>

            <p data-id="element-1743">
              We do not share your personal information with third parties other
              than as follows:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-1744">
              <li data-id="element-1745">
                When you give us your consent to do so, including if we notify
                you through the Service that the information you provide will be
                shared in a particular manner and you provide such information;
              </li>
              <li data-id="element-1746">
                With third party vendors, consultants and service providers who
                perform functions on our behalf, but we limit their use of the
                information as is reasonably necessary to carry out their work;
              </li>
              <li data-id="element-1747">
                When we believe in good faith that we are lawfully authorized or
                required to do so or that doing so is reasonably necessary or
                appropriate to comply with laws or respond to lawful requests,
                legal process or legal authorities;
              </li>
              <li data-id="element-1748">
                When we believe in good faith that doing so is reasonably
                necessary or appropriate to protect our rights, property or
                safety or that of our employees, agents, users or others,
                including to enforce our agreements and policies or to enforce
                our Terms of Use including investigation of potential violations
                of our Terms of Use;
              </li>
              <li data-id="element-1749">
                In extraordinary circumstances, such as to respond to an
                emergency or for reasons of national security, an urgent matter
                of public or individual safety or other issues of dire
                importance;
              </li>
              <li data-id="element-1750">
                In connection with, or during negotiations of, a merger,
                consolidation, sale of our corporate assets or equity,
                financing, acquisition, corporate reorganization, strategic
                alliance or in any other similar situation where personal
                information may be transferred as one of our business assets;
              </li>
              <li data-id="element-1751">
                If you post information to our bulletin board or blog
                (collectively, "Public Forums"), such information, along with
                your email address, will be publicly available to all persons
                accessing that Public Forum. We are not responsible for any
                information you submit to a Public Forum or the subsequent use
                of such information by third parties.
              </li>
            </ul>

            <p data-id="element-1752">
              We may also share aggregated or other data that does not directly
              identify you.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1753">
              4. Your Choices with Respect to Personal Information
            </h3>

            <p data-id="element-1754">
              We may send information to you regarding our products, services
              and special offers or those of selected third parties, unless you
              have opted not to receive such communications or such
              communications are prohibited by law. If you do not wish to
              receive such email, regular mail or other messages, you may opt
              out at the time of registration or information collection by
              logging into your account settings and updating your contact
              preferences.
            </p>

            <p data-id="element-1755">
              Please note that even if you opt out of receiving email or other
              communications from us, we may find it necessary to continue to
              communicate with you regarding your use of the Service or the
              Software, such as messages related to transactions or services you
              have specifically requested, in response to any email from you to
              us, to notify you of updates or changes to our policies and
              procedures, or to otherwise provide you with information we
              believe is important to users. Our systems may require time to
              update, so your opt-out requests may not be updated immediately.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1756">
              5. Protection of Your Personal Information
            </h3>

            <p data-id="element-1757">
              We take all reasonable measures to help protect your personal
              information in an effort to prevent loss, misuse and unauthorized
              access, disclosure, alteration and destruction.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1758">
              6. Third Party Links
            </h3>

            <p data-id="element-1759">
              The Service may contain links to other websites at which personal
              information is collected. This Privacy Policy does not apply to
              linked sites and we are not responsible for the content or privacy
              and security practices of those sites. Any personal information
              you provide to a linked site is provided directly to a third party
              and is subject to such third party's privacy policy. We encourage
              you to learn more about such third parties' privacy and security
              practices and policies before providing them with any personal
              information.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1760">
              7. Changes in Privacy Policy
            </h3>

            <p data-id="element-1761">
              As the need arises, we may change this Privacy Policy at any time.
              We will provide notice of changes to our Privacy Policy by
              indicating on the Policy the date it was last updated and making
              the updated Privacy Policy available through our website. Your use
              of the Service or Software following the posting of the updated
              Privacy Policy constitutes your consent to all changes. We
              encourage you to review this Privacy Policy whenever you access or
              use our Service or Software to make sure you understand how
              personal information we collect may be used or disclosed.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1762">
              8. Contacting Us
            </h3>

            <p data-id="element-1763">
              If you have any questions or comments about this Privacy Policy or
              our practices relating to the Service or Software, or if you
              believe we have not complied with this Privacy Policy, please
              contact us at{' '}
              <a href="mailto:contact@thruline.co" className="text-violet-electric hover:underline" data-id="element-1764">

                contact@thruline.co
              </a>
              .
            </p>
          </section>
        </div>
      </article>
    </div>;
}